import { render, staticRenderFns } from "./yyzwz.vue?vue&type=template&id=48dd80be"
import script from "./yyzwz.vue?vue&type=script&lang=js"
export * from "./yyzwz.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports